import React, { useEffect, useState } from 'react';
import network from '../../../assets/sso/networks.svg';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { UserData } from '../../../types/user.types';
import { NETWORKS } from '../../../constants/networks.config';
import NetworkItem from '../../../components/NetworkItem';
const Networks: React.FC = () => {
    const [user, setUser] = useState<UserData | null>(null);
    const userId = useSelector((state: RootState) => state.user.id);
    const isSsoUser = useSelector((state: RootState) => state.user.isSsoUser);
    const url = `/api/users`;

    useEffect(() => {
        const fetchUser = async () => {
            const response = await axios.get(url + '/' + userId);
            const user = response.data;
            setUser(user);
        };
        fetchUser();
    }, [url, userId]);

    return (
        <div className="flex flex-col">
            <div className="flex items-center justify-start gap-2 w-full">
                <img className="h-[40px]" src={network} alt="networks icon" />
                <div
                    className={
                        'font-medium medium-small ' +
                        (isSsoUser === false ? 'text-heavy' : 'text-medium')
                    }
                >
                    Mes réseaux
                </div>
            </div>
            {user ? (
                <div className="flex flex-col mt-6 gap-2 w-full">
                    {NETWORKS.map(networkConfig => (
                        <NetworkItem
                            key={networkConfig.key}
                            logo={networkConfig.logo}
                            displayName={networkConfig.displayName}
                            variant="status"
                            isConnected={!!user[networkConfig.key]}
                            sizeClass="small"
                        />
                    ))}
                </div>
            ) : (
                <p>Chargement...</p>
            )}
        </div>
    );
};

export default Networks;
